module.exports = global["rpBreakpoints"] = require("-!/var/www/html/node_modules/rp-mq-breakpoints/lib/index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/index.js
// module id = 56
// module chunks = 0